export default {
  props: {
    failedConnectionWithAxios: {
      required: false,
      default: false,
      type: Boolean,
    },
  },

  methods: {
    reloadPage() {
      window.location.reload();
    },
  },

  computed: {
    axiosFail() {
      return this.failedConnectionWithAxios;
    },
  },
};
